import { jsx as _jsx } from "react/jsx-runtime";
import { useApplication } from '../../Contexts/ApplicationContext';
import { observer } from 'mobx-react-lite';
import { PaymentFrame } from './PaymentFrame';
export var IframePaymentPage = observer(function () {
    var stepController = useApplication().stepController;
    var paymentUrl = 'paymentUrl' in stepController.currentStep
        ? stepController.currentStep.paymentUrl
        : undefined;
    return _jsx(PaymentFrame, { url: paymentUrl });
});
